export default __webpack_public_path__ + "static/media/TotalReactivepower.3cdb16cb.svg";